"use client";

import { createContext, ReactNode, useContext } from "react";

import { useStack } from "./stack/use-stack";

type ShareDataContextType = {
  shareData: ShareData | null;
  pushShareData: (data: ShareData) => void;
  popShareData: () => void;
};

const ShareDataContext = createContext<ShareDataContextType | undefined>(
  undefined,
);

type Props = {
  children: ReactNode;
};

export function ShareDataProvider({ children }: Props) {
  const {
    top: shareData,
    push: pushShareData,
    pop: popShareData,
  } = useStack<ShareData>();

  return (
    <ShareDataContext.Provider
      value={{ shareData, pushShareData, popShareData }}
    >
      {children}
    </ShareDataContext.Provider>
  );
}

export function useShareData() {
  const context = useContext(ShareDataContext);
  if (context === undefined) {
    throw new Error("useShareData must be used within a ShareDataProvider");
  }
  return context;
}
